import {lazy} from 'react';
import {
    ADD_ROUTE,
    ADMIN_ROUTE,
    CREATE_ADD,
    FAVOURITES_ROUTE,
    PROFILE_ROUTE,
    SHOP_ROUTE,
    MAIN_ROUTE,
    BLOG_ROUTE,
    ABOUT_US_ROUTE,
    PHOTO_GALLERY_ROUTE,
    PLACES_ROUTE,
    ADD_CHECKED_ROUTE,
    GLOBAL_REVIEWS_ROUTE,
    EDIT_ADD_ROUTE,
    CHAT_ROUTE,
    SELECTION_VIEW_ROUTE,
    SELECTION_CREATE_ROUTE,
    OWNER_ANALYTICS_ROUTE,
    ADMIN_ANALYTICS_ROUTE,
    MAP_SEARCH_ROUTE,
    ADMIN_AREA_EDITOR_ROUTE,
    ADMIN_ROUTE_DEBUG_ROUTE,
    ADMIN_CHATS_ROUTE,
    PROMOTION_ROUTE,
    OWNER_PROMOTIONS_ROUTE,
    PAYMENT_RETURN_ROUTE,
    REQUEST_CHAT_ROUTE,
    DIRECT_CHATS_ROUTE,
    MESSAGE_ROUTE,
    REQUEST_OFFER_CREATE_ROUTE,
    OWNER_REQUESTS_ROUTE,
    OWNER_BOOKINGS_ROUTE,
    BOOKING_BROWSER_TEST_ROUTE,
    OWNER_RESULTS_ROUTE,
    ADMIN_REQUESTS_ROUTE,
    ADMIN_GEO_ROUTE,
    ADMIN_REVIEWS_ROUTE,
    OWNER_CALENDAR_ROUTE,
    ADMIN_CALENDAR_SNAPSHOTS_ROUTE,
    ADMIN_CALENDAR_CONNECTIONS_ROUTE,
    OWNER_CALENDARS_ROUTE,
    NOTIFICATIONS_SETUP_ROUTE,
    BROWSER_HANDOFF_ROUTE,
    APP_START_ROUTE,
    LEGACY_PHONE_TRANSFER_ROUTE,
    AVITO_CALLBACK_ROUTE,
} from "./utils/consts";

// Заменяем прямые импорты на асинхронные с lazy()
const AdminPage = lazy(() => import("./pages/AdminPage/AdminPage"));
const AdminAnalyticsPage = lazy(() => import("./pages/AdminAnalyticsPage/AdminAnalyticsPage"));
const AdminAddsCheckPage = lazy(() => import("./pages/AdminAddsCheckPage/AdminAddsCheckPage"));
const AdminAreaEditorPage = lazy(() => import("./pages/AdminAreaEditorPage/AdminAreaEditorPage"))
const AdminRouteDebugPage = lazy(() => import("./pages/AdminRouteDebugPage/AdminRouteDebugPage"));
const AdminChatsPage = lazy(() => import("./pages/AdminChatsPage/AdminChatsPage"));

const ProfilePage = lazy(() => import("./pages/ProfilePage/ProfilePage"));
const ShopPage = lazy(() => import("./pages/ShopPage/ShopPage"));
const AddPage = lazy(() => import("./pages/AddPage/AddPage"));
const FavouritesPage = lazy(() => import("./pages/FavouritesPage/FavouritesPage"));
const CreateAddPage = lazy(() => import("./pages/CreateAddPage/CreateAddPage"));
const MainPage = lazy(() => import("./pages/MainPage/MainPage"));
const BlogPage = lazy(() => import("./pages/BlogPage/BlogPage"));
const AboutUsPage = lazy(() => import("./pages/AboutUsPage/AboutUsPage"));
const PhotoGalleryPage = lazy(() => import("./pages/PhotogalleryPage/PhotoGalleryPage"));
const PlacesPage = lazy(() => import("./pages/PlacePage/PlacesPage/PlacesPage"));
const PlacePage = lazy(() => import("./pages/PlacePage/PlacePage/PlacePage"));
const GlobalReviewsPage = lazy(() => import("./pages/GlobalReviewsPage/GlobalReviewsPage"));
const EditAddPage = lazy(() => import("./pages/EditAddPage/EditAddPage"));

const SelectionCreatePage = lazy(() => import("./pages/SelectionCreatePage/SelectionCreatePage"));
const SelectionViewPage = lazy(() => import("./pages/SelectionViewPage/SelectionViewPage"));

const ChatPage = lazy(() => import("./pages/ChatPage/ChatPage/ChatPage"))
const ChatsPage = lazy(() => import("./pages/ChatPage/ChatsPage/ChatsPage"))

const OwnerAnalyticsPage = lazy(() => import("./pages/OwnerAnalyticsPage/OwnerAnalyticsPage"));

const MapSearchPage = lazy(() => import("./pages/MapSearchPage/MapSearchPage"));

const PromotionPage = lazy(() => import("./pages/PromotionPage/PromotionPage"));
const OwnerPromotionsPage = lazy(() => import("./pages/OwnerPromotionsPage/OwnerPromotionsPage"));

const PaymentReturnPage = lazy(() => import("./pages/PaymentReturnPage/PaymentReturnPage"));

const RequestChatPage = lazy(() => import("./pages/RequestChatPage/RequestChatPage"));

const DirectChatsPage = lazy(() => import("./pages/DirectChatPage/DirectChatsPage/DirectChatsPage"));
const DirectChatPage = lazy(() => import("./pages/DirectChatPage/DirectChatPage/DirectChatPage"));


const MessagesHubPage = lazy(() => import("./pages/MessagesHubPage/MessagesHubPage"));

const RequestOfferCreatePage = lazy(() => import("./pages/RequestOfferCreatePage/RequestOfferCreatePage"));
const OwnerRequestsPage = lazy(() => import("./pages/OwnerRequestsPage/OwnerRequestsPage"));
const OwnerBookingsPage = lazy(() => import("./pages/OwnerBookingsPage/OwnerBookingsPage"));
const BookingBrowserTestPage = lazy(() => import("./pages/BookingBrowserTestPage/BookingBrowserTestPage"));
const OwnerResultsPage = lazy(() => import("./pages/OwnerResultsPage/OwnerResultsPage"));
const AdminRequestsPage = lazy(() => import("./pages/AdminRequestsPage/AdminRequestsPage"));

const SeoLandingPage = lazy(() => import("./pages/SeoLandingPage/SeoLandingPage"));

const AdminGeoPage = lazy(() => import("./pages/AdminGeoPage/AdminGeoPage"));
const AdminReviewsPage = lazy(() => import("./pages/AdminReviewsPage/AdminReviewsPage"));

const OwnerCalendarPage = lazy(() => import("./pages/OwnerCalendarPage/OwnerCalendarPage"));

const AdminCalendarSnapshotsPage = lazy(() => import('./pages/AdminCalendarSnapshotsPage/AdminCalendarSnapshotsPage'));
const AdminCalendarConnectionsPage = lazy(() => import('./pages/AdminCalendarConnectionsPage/AdminCalendarConnectionsPage'));
const OwnerCalendarsPage = lazy(() => import('./pages/OwnerCalendarsPage/OwnerCalendarsPage'));

const NotificationsSetupPage = lazy(() => import("./pages/NotificationsSetupPage/NotificationsSetupPage"));
const BrowserHandoffPage = lazy(() => import("./pages/BrowserHandoffPage/BrowserHandoffPage"));
const AppStartPage = lazy(() => import("./pages/AppStartPage/AppStartPage"));
const LegacyPhoneTransferPage = lazy(() => import("./pages/LegacyPhoneTransferPage/LegacyPhoneTransferPage"));

const AvitoCallbackPage = lazy(() => import("./pages/AvitoCallbackPage/AvitoCallbackPage"));

export const authRoutes = [
    {
        path: ADMIN_ROUTE,
        Component: AdminPage
    },
    {
        path: CREATE_ADD,
        Component: CreateAddPage
    },
    {
        path: NOTIFICATIONS_SETUP_ROUTE,
        Component: NotificationsSetupPage,
        exact: true
    },
    {
        path: ADD_CHECKED_ROUTE,
        Component: AdminAddsCheckPage
    },
    {
        path: EDIT_ADD_ROUTE + "/:id",
        Component: EditAddPage
    },
    {
        path: SELECTION_CREATE_ROUTE,
        Component: SelectionCreatePage
    },
    {
        path: OWNER_ANALYTICS_ROUTE,
        Component: OwnerAnalyticsPage
    },
    {
        path: ADMIN_ANALYTICS_ROUTE,
        Component: AdminAnalyticsPage
    },
    {
        path: ADMIN_AREA_EDITOR_ROUTE,
        Component: AdminAreaEditorPage
    },
    {
        path: ADMIN_ROUTE_DEBUG_ROUTE,
        Component: AdminRouteDebugPage
    },
    {
        path: ADMIN_CHATS_ROUTE,
        Component: AdminChatsPage
    },
    {
        path: OWNER_PROMOTIONS_ROUTE,
        Component: OwnerPromotionsPage
    },
    {
        path: PROMOTION_ROUTE + "/:id",
        Component: PromotionPage
    },
    {
        path: PAYMENT_RETURN_ROUTE,
        Component: PaymentReturnPage
    },
    {
        path: REQUEST_CHAT_ROUTE,
        Component: RequestChatPage
    },
    {
        path: DIRECT_CHATS_ROUTE,
        Component: DirectChatsPage,
        exact: true
    },
    {
        path: DIRECT_CHATS_ROUTE + "/:id",
        Component: DirectChatPage
    },
    {
        path: `${REQUEST_OFFER_CREATE_ROUTE}/:requestId`,
        Component: RequestOfferCreatePage
    },
    {
        path: OWNER_REQUESTS_ROUTE,
        Component: OwnerRequestsPage
    },
    ...(process.env.REACT_APP_BOOKING_DEMO_UI_ENABLED === "true" ? [{
        path: OWNER_BOOKINGS_ROUTE,
        Component: OwnerBookingsPage,
        exact: true
    }, {
        path: OWNER_RESULTS_ROUTE,
        Component: OwnerResultsPage,
        exact: true
    }] : []),
    {
        path: ADMIN_REQUESTS_ROUTE,
        Component: AdminRequestsPage
    },
    {
        path: ADMIN_GEO_ROUTE,
        Component: AdminGeoPage
    },
    {
        path: ADMIN_REVIEWS_ROUTE,
        Component: AdminReviewsPage
    },
    {
        path: OWNER_CALENDAR_ROUTE + "/:id",
        Component: OwnerCalendarPage
    },
    {
        path: ADMIN_CALENDAR_SNAPSHOTS_ROUTE,
        Component: AdminCalendarSnapshotsPage
    },
    {
        path: ADMIN_CALENDAR_CONNECTIONS_ROUTE,
        Component: AdminCalendarConnectionsPage
    },
    {
        path: OWNER_CALENDARS_ROUTE,
        Component: OwnerCalendarsPage
    },
];

export const publicRoutes = [
    ...(process.env.NODE_ENV === 'development' && process.env.REACT_APP_BOOKING_DEMO_UI_ENABLED === 'true' ? [{
        path: BOOKING_BROWSER_TEST_ROUTE,
        Component: BookingBrowserTestPage,
        exact: true
    }] : []),
    {
        path: LEGACY_PHONE_TRANSFER_ROUTE,
        Component: LegacyPhoneTransferPage,
        exact: true
    },
    {
        path: AVITO_CALLBACK_ROUTE,
        Component: AvitoCallbackPage,
        exact: true
    },
    {
        path: APP_START_ROUTE,
        Component: AppStartPage,
        exact: true
    },
    {
        path: SHOP_ROUTE,
        Component: ShopPage,
        exact: true
    },
    {
        path: ADD_ROUTE + "/:id",
        Component: AddPage
    },
    {
        path: PROFILE_ROUTE + "/:id",
        Component: ProfilePage
    },
    {
        path: MAIN_ROUTE,
        Component: MainPage
    },
    {
        path: BLOG_ROUTE,
        Component: BlogPage
    },
    {
        path: ABOUT_US_ROUTE,
        Component: AboutUsPage
    },
    {
        path: PHOTO_GALLERY_ROUTE,
        Component: PhotoGalleryPage
    },
    {
        path: PLACES_ROUTE,
        Component: PlacesPage,
        exact: true
    },
    {
        path: PLACES_ROUTE + "/:id",
        Component: PlacePage
    },
    {
        path: GLOBAL_REVIEWS_ROUTE,
        Component: GlobalReviewsPage
    },
    {
        path: MESSAGE_ROUTE,
        Component: MessagesHubPage,
        exact: true
    },
    {
        path: CHAT_ROUTE,
        Component: ChatsPage, // здесь список чатов
        exact: true
    },
    {
        path: CHAT_ROUTE + "/:id",
        Component: ChatPage, // здесь конкретный чат
    },
    {
        path: FAVOURITES_ROUTE,
        Component: FavouritesPage
    },
    {
        path: SELECTION_VIEW_ROUTE + "/:id",
        Component: SelectionViewPage // Сюда перейдет гость по ссылке из WhatsApp
    },
    {
        path: MAP_SEARCH_ROUTE,
        Component: MapSearchPage
    },
    {
        path: BROWSER_HANDOFF_ROUTE,
        Component: BrowserHandoffPage,
        exact: true
    },
    {
        path: "/:slug",
        Component: SeoLandingPage,
        exact: true
    }
];